/**
 * Prefixes an artefact card title with its task serial ("NSV Growth" -> "1. NSV Growth").
 *
 * The serial is the task's 1-based position within the answer, so it matches the number in
 * the Analysis Summary's citation badges and the left panel's task label. Only the displayed
 * label is prefixed - `item.title` stays raw for export slide titles and analytics payloads.
 */
export function formatTaskTitleWithSerial(title: string, taskSerial?: number): string {
    return taskSerial == null ? title : `${taskSerial}. ${title}`;
}
